import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MemberQuotaSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let n = 0;
    const tick = async () => {
      if (n++ >= 30) { setStatus("timeout"); return; }
      try {
        const r = await axios.get(`${API}/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        setTimeout(tick, 2000);
      } catch { setStatus("error"); }
    };
    tick();
  }, [sessionId]);

  return (
    <section className="container-page py-24 text-center" data-testid="quota-success-page">
      {status === "paid" ? (
        <>
          <CheckCircle2 className="h-16 w-16 text-emerald-600 mx-auto" />
          <div className="overline mt-8">Quota confirmada</div>
          <h1 className="display-heading text-4xl sm:text-5xl mt-6">Obrigado.</h1>
          <span className="accent-rule mt-8 inline-block" />
          <p className="mt-8 text-base text-[hsl(var(--muted-foreground))] leading-relaxed max-w-xl mx-auto">
            A sua quota anual foi paga com sucesso. Em breve receberá no seu email a
            <strong> Declaração de Donativo</strong> em PDF para efeitos contabilísticos.
          </p>
        </>
      ) : status === "checking" ? (
        <>
          <Loader2 className="h-12 w-12 text-[hsl(var(--primary))] mx-auto animate-spin" />
          <div className="overline mt-6">A confirmar pagamento</div>
          <h1 className="display-heading text-3xl mt-4">Um momento…</h1>
        </>
      ) : (
        <>
          <h1 className="display-heading text-3xl mt-6">A verificar o pagamento.</h1>
          <p className="mt-4 text-[hsl(var(--muted-foreground))]">Se o pagamento foi bem-sucedido, receberá email de confirmação em breve.</p>
        </>
      )}
      <Link to="/membros" className="btn-outline mt-12 inline-flex" data-testid="quota-back-to-members">
        Voltar à área de sócios
      </Link>
    </section>
  );
}
